import RestX from 'highered-utils/restx';
import UniversityService from './UniversityService';

const INTERCOM_DEFAULT_SETTINGS = {
    app_id: process.env.VUE_APP_INTERCOM_APP_ID,
};

class IntercomService {
    static currentLogInMethod = null; // The current method used to log in

    static SocialAuthLogin = providerName => `SocialAuth-${providerName}`; // SocialAuth description of login method
    static EmailLogin = 'Email'; // Email description of login method

    static show() {
        if (!window.Intercom) {
            return;
        }
        window.Intercom('show');
    }

    static hide() {
        if (!window.Intercom) {
            return;
        }
        window.Intercom('hide');
    }

    static setUserData(logInMethod = 'Unknown') {
        if (!window.Intercom) {
            return;
        }

        RestX.getInterfaces()
            .user.me.get()
            .then(async res => {
                const userData = res.data || {};
                // Check if user data is valid
                if (!userData || !userData.id) {
                    return;
                }

                // Set user id
                const dataObject = {
                    user_id: userData.id,
                };

                // Set first name and last name
                if (userData.firstName || userData.lastName) {
                    dataObject.name = (userData.firstName || '').concat(
                        userData.lastName ? ' ' : '',
                        userData.lastName || ''
                    );
                }

                // Set email
                if (userData.email) {
                    dataObject.email = userData.email;
                }

                // Set avatar
                if (userData.avatar) {
                    dataObject.avatar = {
                        type: 'avatar',
                        image_url: userData.avatar,
                    };
                }

                // Sets school portal name
                const schoolData = await UniversityService.getCurrentSchoolData();
                if (schoolData && schoolData.id) {
                    dataObject.school_portal = schoolData.name;
                }

                // Set login method.
                logInMethod = this.currentLogInMethod || logInMethod;
                if (this.currentLogInMethod === null) {
                    this.currentLogInMethod = logInMethod;
                }
                if (logInMethod) {
                    dataObject.login_method = logInMethod;
                }

                // Overwrite intercom settings
                window.intercomSettings = {
                    ...dataObject,
                    ...INTERCOM_DEFAULT_SETTINGS,
                };
                window.Intercom('boot', window.intercomSettings);
            });
    }

    static reset() {
        if (!window.Intercom) {
            return;
        }

        window.Intercom('shutdown');
        window.intercomSettings = INTERCOM_DEFAULT_SETTINGS;
        window.Intercom('boot', INTERCOM_DEFAULT_SETTINGS);
    }

    static update() {
        if (!window.Intercom) {
            return;
        }

        window.Intercom('update');
    }
}

export default IntercomService;
